import { TableCell, TableRow } from '@mui/material';
import { RecruiterContact } from 'features/co-pilot/co-pilot.types';
import PaiLink from 'features/ui/base-components/pai-link';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  contact: RecruiterContact;
}

const RecruiterContactItem: React.FC<Props> = ({ contact }) => {
  const { t } = useTranslation();

  const positions = contact.currentCompanies.map((company) => company.title).join(', ');
  const companies = contact.currentCompanies.map((company) => company.companyName).join(', ');

  return (
    <TableRow>
      <TableCell>
        <PaiLink
          text={!_.isNil(contact.name) && contact.name.trim() ? contact.name : t('linkedinUser')}
          size={'md'}
          variant={'primary'}
          underline={'always'}
          href={contact.url?.replace('talent/profile', 'in')}
          target={'_blank'}
        />
      </TableCell>
      <TableCell>{positions || '-'}</TableCell>
      <TableCell>{companies || '-'}</TableCell>
    </TableRow>
  );
};

export default RecruiterContactItem;
